module.exports = __webpack_public_path__ + "img/nadia.ce1c4a9d.png";